import React, { Component } from 'react'
import Link from '../../utils/link'

class ProjectSmallCard extends Component {

  render() {
    const { slug, title, databaseId, address, mainImage, details, feature, postType, onClick } = this.props

    let pathName = `/${postType}/${slug}/`
    let heading = `${title}`
    if (address?.hideAddress) pathName = `/project/${address.suburb.toLowerCase().replace(/ /gi, '-')}-${databaseId}/`

    return (
      <div className='property'>
        <div className='property__image'>
          <img src={mainImage && mainImage.url} alt={title} />
          <div className='property__rollover'>
            <div className='property__title'>
              <h4 dangerouslySetInnerHTML={{ __html: heading }} />
            </div>
          </div>
        </div>
        <Link className='property__link' to={pathName} />
      </div>
    )
  }
}

export default ProjectSmallCard
